import checkout from "./form";

const {
  formField: { firstName, lastName, username, email, plainPassword, payGroups, role, status },
} = checkout;

export default {
  [firstName.name]: "",
  [lastName.name]: "",
  [username.name]: "",
  [email.name]: "",
  [plainPassword.name]: "",
  [payGroups.name]: [],
  [role.name]: null,
  [status.name]: "inactive",
};
